import { FC, useContext, useEffect, useState } from "react";
import { BoardContext, SocketContext, TeamContext, UserContext } from "../../../../context";
import { CornerCirclesBackground, MainButton, RegularInput } from "../../../atoms";

import logoUppiness from "../../../../assets/icons/logoUppiness.svg";
import { useTranslation } from "react-i18next";

const RejoinTheGame: FC<{}> = () => {
    const { t } = useTranslation();
    const { socket } = useContext(SocketContext);
    const { roomUsers } = useContext(TeamContext);
    const { setUserDataWhenUserRejoinsTheGame } = useContext(UserContext);
    const { setDidUserRejoinTheGame } = useContext(BoardContext);
    const [email, setEmail] = useState(localStorage["userEmailInCaseHeLogsOut"]);  
    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

    const rejoinTheGame = () => {
        setUserDataWhenUserRejoinsTheGame(email);
        socket?.emit("reconnection", {email: email, matchId: urlTokenExtracted});
        setDidUserRejoinTheGame(true);
    }

    useEffect(() => {
        setUserDataWhenUserRejoinsTheGame(email);
        socket?.emit("reconnection", {email: email, matchId: urlTokenExtracted});
        setDidUserRejoinTheGame(true);
    }, [email, setDidUserRejoinTheGame, setUserDataWhenUserRejoinsTheGame, socket]);

    useEffect(() => {
        roomUsers();
    }, [roomUsers]);

    const handleKeyPress = (event: any) => {
        setEmail(event);
    }

    return (
        <CornerCirclesBackground>
            <div className="center_horizontally_and_vertically">
                <div className="log_in">
                    <img className="log_in_logo" src={logoUppiness} alt="Uppiness Logo" />

                    <div className="elipse" />

                    <div className="center_rejoin_elements">
                        <div className="rejoin_elements_holder">
                            <div className="input_wrapper" style={{ paddingTop: '30px' }}>
                                <div className="regular_input">
                                    <RegularInput
                                        label={t("emailBigText")}
                                        value={email}
                                        onChange={(value: string) => handleKeyPress(value)}
                                        catchEnter={(value: boolean) => rejoinTheGame()}
                                        fieldName="email"
                                        maxLength={50}
                                    />
                                </div>
                            </div>

                            <div className="rejoin_button_wrapper">
                                <form onSubmit={() => rejoinTheGame()}>
                                    <div className="main_button-wrapper">
                                        <MainButton
                                            type="big"
                                            text={t("rejoinTheGameText")}
                                            clickHandler={() => rejoinTheGame()}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CornerCirclesBackground>

    )
}

export default RejoinTheGame;